var $da3005c7bd72b0a8$exports = {};
$da3005c7bd72b0a8$exports = {
  "decrease": function decrease(args) {
    return "Diminuir ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Aumentar ".concat(args.fieldLabel);
  },
  "numberField": "Campo de n\xFAmero"
};
export { $da3005c7bd72b0a8$exports as default };